// @ts-nocheck
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/CommonHandlers/LoadRealTimeInventory";
import { addToChainAfter } from "@toolkit/Modules/client-framework/HandlerCreator";

addToChainAfter(chain, RequestDataFromApi, props => {
    if (!props.error && props.apiResult && props.apiResult.realTimeInventoryResults) {
        props.apiResult.realTimeInventoryResults?.forEach(r => {
            const availabilityCode = r.additionalResults?.["availabilityCode"];
            const availabilityDelayDays = r.additionalResults?.["availabilityDelayDays"];
            const additionnalMessage = r.additionalResults?.["availabilityMessage"];
            if (r.inventoryAvailabilityDtos) {
                r.inventoryAvailabilityDtos.forEach(uom => {
                    if (uom.availability) {
                        uom.availability.availabilityCode = availabilityCode;
                        uom.availability.availabilityDelayDays = availabilityDelayDays;
                        uom.availability.additionnalMessage = additionnalMessage;
                    }
                });
            }
        });
    }
});
